<app-modal
  [title]="'admin.customers.reportModel.title' | transloco"
  [subtitle]="'admin.customers.reportModel.subtitle' | transloco"
  [errorMessage]="errorMessage() || null"
  [isLoading]="isLoading()"
  [isSubmitting]="isSaving()"
  [isDisabled]="!selected()"
  [confirmLabel]="'admin.customers.reportModel.confirmLabel' | transloco"
  [submittingLabel]="'admin.customers.reportModel.submittingLabel' | transloco"
  (confirm)="onConfirm()"
  (cancelled)="cancel()"
  icon="bi bi-file-earmark-bar-graph"
>
  <div class="report-model-layout">
    <!-- Opções (sidebar esquerda) -->
    <aside class="report-model-sidebar">
      <div class="report-model-sidebar__label text-secondary-brand">
        {{ 'admin.customers.reportModel.optionsLabel' | transloco }}
      </div>
      <div class="report-model-options">
        @for (opt of options; track opt.value) {
          <button
            type="button"
            class="report-model-option"
            [class.report-model-option--selected]="selected() === opt.value"
            [attr.aria-pressed]="selected() === opt.value"
            (click)="select(opt.value)"
          >
            <i [class]="opt.icon + ' report-model-option__icon'"></i>
            <span class="report-model-option__label">{{ opt.labelKey | transloco }}</span>
            @if (selected() === opt.value) {
              <i class="bi bi-check-circle-fill report-model-option__check"></i>
            }
          </button>
        }
      </div>
    </aside>

    <!-- Prévia do relatório (foco principal) -->
    <section class="report-model-preview">
      <header class="report-model-preview__header">
        <span class="report-model-preview__title">
          <i class="bi bi-file-earmark-text me-2"></i>
          {{ 'admin.customers.reportModel.previewTitle' | transloco }}
        </span>
        @if (selectedPdfUrl()) {
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="openInNewTab()">
            <i class="bi bi-box-arrow-up-right me-2"></i>
            {{ 'admin.customers.reportModel.openInNewTab' | transloco }}
          </button>
        }
      </header>

      <div class="report-model-preview__body">
        @if (selectedPdfUrl(); as pdf) {
          <ngx-extended-pdf-viewer [src]="pdf" [showToolbar]="false" height="100%"> </ngx-extended-pdf-viewer>
        } @else {
          <div class="report-model-preview__empty text-secondary-brand">
            <i class="bi bi-file-earmark-x"></i>
            <span>
              @if (selected()) {
                {{ 'admin.customers.reportModel.previewUnavailable' | transloco }}
              } @else {
                {{ 'admin.customers.reportModel.previewHint' | transloco }}
              }
            </span>
          </div>
        }
      </div>
    </section>
  </div>
</app-modal>
